(function () {
  'use strict';

  if (window.__YF_MOBILE_BOTTOM_NAV_V9__) return;
  window.__YF_MOBILE_BOTTOM_NAV_V9__ = true;

  var MOBILE_QUERY = '(max-width: 749px)';
  var syncScheduled = false;
  var cartRefreshTimer = null;
  var cartRequestToken = 0;
  var menuHost = null;
  var externalChatObserver = null;
  var floatingLookforTarget = null;
  var lookforLayerHosts = [];

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MOBILE_QUERY).matches);
  }

  function closest(element, selector) {
    if (!element || element === document || !element.closest) return null;
    return element.closest(selector);
  }

  function navElement() {
    return document.querySelector('[data-yf-mobile-bottom-nav]');
  }


  function getMenuHost() {
    var trigger = document.querySelector('[data-yf-mobile-menu-trigger]');
    if (!trigger) return null;
    var targetId = trigger.getAttribute('target');
    if (!targetId) return null;
    menuHost = document.getElementById(targetId);
    return menuHost;
  }

  function getMenuDialog() {
    var host = getMenuHost();
    return host && host.querySelector('dialog');
  }

  function portalNavIntoMenu() {
    if (!isMobile()) return;
    var nav = navElement();
    var dialog = getMenuDialog();
    if (!nav || !dialog || !dialog.open || !document.body) return;

    /* The quick bar should not sit inside or on top of the full mobile menu.
       Keep it attached to <body> and hide it for the duration of the menu. */
    if (nav.parentNode !== document.body) document.body.appendChild(nav);
    nav.removeAttribute('data-yf-mobile-nav-in-menu');
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.add('yf-mobile-menu-open');
  }

  function restoreNavToBody() {
    var nav = navElement();
    if (!document.body) return;
    document.body.classList.remove('yf-mobile-menu-open');
    if (!nav) return;
    if (nav.parentNode !== document.body) document.body.appendChild(nav);
    nav.removeAttribute('data-yf-mobile-nav-in-menu');
    nav.removeAttribute('aria-hidden');
  }

  function closeMenu(callback) {
    var host = getMenuHost();
    var dialog = getMenuDialog();
    if (!host || !dialog || !dialog.open) {
      if (callback) callback();
      return;
    }

    host.dispatchEvent(new CustomEvent('modal-close', { bubbles: true }));
    window.setTimeout(function () {
      restoreNavToBody();
      if (callback) callback();
    }, 360);
  }

  function toggleMenu() {
    var trigger = document.querySelector('[data-yf-mobile-menu-trigger]');
    var dialog = getMenuDialog();
    if (dialog && dialog.open) {
      closeMenu();
      return;
    }
    if (!trigger) return;
    trigger.click();
    [0, 40, 120, 350].forEach(function (delay) {
      window.setTimeout(portalNavIntoMenu, delay);
    });
  }

  function setLocationOpen(open) {
    var widget = document.getElementById('yf-location-widget');
    var toggle = document.getElementById('yf-location-toggle');
    var panel = document.getElementById('yf-location-panel');
    if (!widget || !panel) return false;

    widget.setAttribute('data-open', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    syncLocationState();
    return true;
  }

  function toggleLocation() {
    if (window.YFLocationFilter && typeof window.YFLocationFilter.toggle === 'function') {
      window.YFLocationFilter.toggle();
      syncLocationState();
      return;
    }

    var widget = document.getElementById('yf-location-widget');
    if (!widget) return;
    setLocationOpen(widget.getAttribute('data-open') !== 'true');
  }

  function syncLocationState() {
    var nav = navElement();
    if (!nav) return;
    var button = nav.querySelector('[data-yf-mobile-location-button]');
    var dot = nav.querySelector('[data-yf-mobile-location-dot]');
    var widget = document.getElementById('yf-location-widget');
    var summary = document.getElementById('yf-location-summary');
    if (!button || !widget) return;

    var open = widget.getAttribute('data-open') === 'true';
    var text = summary ? (summary.textContent || '').trim().toLowerCase() : 'all';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (dot) dot.hidden = text === '' || text === 'all';
  }

  var LOOKFOR_ENTRY_SELECTOR = '#lookfor-chatbot-entry, .lookfor-chatbot-entry, [data-lookfor-chatbot-entry]';
  var LOOKFOR_CANDIDATE_SELECTOR = [
    LOOKFOR_ENTRY_SELECTOR,
    'iframe[src*="lookfor.ai" i]',
    'iframe[src*="lookfor" i]',
    'iframe[title*="lookfor" i]',
    '[id*="lookfor-chat" i]',
    '[class*="lookfor-chat" i]',
    '[data-app*="lookfor" i]'
  ].join(', ');

  function elementIsVisible(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var rect = element.getBoundingClientRect();
    if (rect.width < 8 || rect.height < 8) return false;
    var style;
    try { style = window.getComputedStyle(element); } catch (error) { style = null; }
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
    return true;
  }

  function collectLookforCandidates(root, output, visited) {
    root = root || document;
    output = output || [];
    visited = visited || [];
    if (!root || visited.indexOf(root) !== -1) return output;
    visited.push(root);

    try {
      if (root.matches && root.matches(LOOKFOR_CANDIDATE_SELECTOR)) output.push(root);
      if (root.querySelectorAll) {
        Array.prototype.forEach.call(root.querySelectorAll(LOOKFOR_CANDIDATE_SELECTOR), function (candidate) {
          if (output.indexOf(candidate) === -1) output.push(candidate);
        });
      }
    } catch (error) {}

    var hosts = [];
    try {
      hosts = root.querySelectorAll
        ? root.querySelectorAll('[id*="lookfor" i], [class*="lookfor" i], [data-app*="lookfor" i], iframe[src*="lookfor" i]')
        : [];
    } catch (error) {}

    Array.prototype.forEach.call(hosts, function (host) {
      if (host && host.shadowRoot) collectLookforCandidates(host.shadowRoot, output, visited);
    });
    return output;
  }

  function compactLookforTarget(candidate) {
    if (!candidate || !candidate.getBoundingClientRect) return null;
    var target = candidate;
    var parent = candidate.parentElement;
    var lastCompactRect = candidate.getBoundingClientRect();

    /* Select the OUTERMOST compact launcher wrapper. Choosing only the inner
       iframe can leave it trapped beneath a lower-z-index parent. Never climb
       into the full chat panel. */
    while (parent && parent !== document.body) {
      var parentRect = parent.getBoundingClientRect ? parent.getBoundingClientRect() : null;
      var style;
      try { style = window.getComputedStyle(parent); } catch (error) { style = null; }
      if (!parentRect || parentRect.width < 8 || parentRect.height < 8) break;
      if (parentRect.width > 190 || parentRect.height > 190) break;
      if (parentRect.width + 8 < lastCompactRect.width || parentRect.height + 8 < lastCompactRect.height) break;

      if (style && (style.position === 'fixed' || style.position === 'absolute' || style.position === 'sticky')) {
        target = parent;
        lastCompactRect = parentRect;
      }
      parent = parent.parentElement;
    }
    return target;
  }

  function lookforCandidateScore(candidate) {
    if (!elementIsVisible(candidate)) return Number.POSITIVE_INFINITY;
    var target = compactLookforTarget(candidate);
    if (!target || !elementIsVisible(target)) return Number.POSITIVE_INFINITY;
    var rect = target.getBoundingClientRect();
    if (rect.width > 180 || rect.height > 180) return Number.POSITIVE_INFINITY;

    /* Prefer Lookfor's explicit launcher, then compact fixed elements nearest
       the storefront's natural bottom-right launcher position. */
    var score = Math.abs(window.innerWidth - rect.right) + Math.abs(window.innerHeight - rect.bottom);
    try {
      if (candidate.matches && candidate.matches(LOOKFOR_ENTRY_SELECTOR)) score -= 1200;
    } catch (error) {}
    if (String(candidate.tagName || '').toLowerCase() === 'iframe') score -= 250;
    try {
      var style = window.getComputedStyle(target);
      if (style.position === 'fixed') score -= 150;
    } catch (error) {}
    return score;
  }

  function findLookforEntry(root) {
    var candidates = collectLookforCandidates(root || document, [], []);
    var best = null;
    var bestScore = Number.POSITIVE_INFINITY;
    candidates.forEach(function (candidate) {
      var score = lookforCandidateScore(candidate);
      if (score < bestScore) {
        bestScore = score;
        best = candidate;
      }
    });
    return best;
  }

  function setChatSlotDocked(docked) {
    var slot = document.querySelector('[data-yf-mobile-chat-slot]');
    if (!slot) return;
    if (docked) slot.setAttribute('data-yf-chat-docked', 'true');
    else slot.removeAttribute('data-yf-chat-docked');
  }

  function clearLookforLayerHosts() {
    lookforLayerHosts.forEach(function (host) {
      if (host && host.removeAttribute) host.removeAttribute('data-yf-lookfor-layer-host');
    });
    lookforLayerHosts = [];
  }

  function clearLookforFloat(target) {
    target = target || floatingLookforTarget;
    if (target && target.removeAttribute) {
      target.removeAttribute('data-yf-lookfor-floating');
      target.removeAttribute('data-yf-lookfor-front-layer');
      target.removeAttribute('aria-hidden');
      target.style.removeProperty('--yf-lookfor-left');
      target.style.removeProperty('--yf-lookfor-top');
    }
    clearLookforLayerHosts();
    setChatSlotDocked(false);
    if (!target || target === floatingLookforTarget) floatingLookforTarget = null;
  }

  function elevateLookforAncestors(target) {
    clearLookforLayerHosts();
    var node = target && target.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var rect = node.getBoundingClientRect ? node.getBoundingClientRect() : null;
      var style = null;
      try { style = window.getComputedStyle(node); } catch (error) {}

      /* A parent stacking context can keep the native launcher underneath the
         bottom bar even when the launcher itself has the highest z-index.
         Raise every positioned/transformed Lookfor ancestor, not only the
         small visible bubble wrapper. */
      var positioned = style && style.position !== 'static';
      var stackingContext = style && (
        style.transform !== 'none' ||
        style.filter !== 'none' ||
        style.perspective !== 'none' ||
        style.isolation === 'isolate' ||
        parseFloat(style.opacity || '1') < 1
      );
      var compact = rect && rect.width <= 240 && rect.height <= 240;
      var lookforNamed = /lookfor/i.test(String(node.id || '') + ' ' + String(node.className || '') + ' ' + String(node.getAttribute && node.getAttribute('data-app') || ''));

      if (positioned || stackingContext || compact || lookforNamed) {
        node.setAttribute('data-yf-lookfor-layer-host', 'true');
        lookforLayerHosts.push(node);
      }
      node = node.parentElement;
    }
  }

  function positionLookforOverChatSlot(target) {
    var slot = document.querySelector('[data-yf-mobile-chat-slot]');
    if (!slot || !target || !target.getBoundingClientRect) return false;
    var slotRect = slot.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var width = Math.max(44, Math.min(targetRect.width || 56, 76));
    var height = Math.max(44, Math.min(targetRect.height || 56, 76));

    /* Sit the native Lookfor bubble in FRONT of the bar, centered on the
       fifth slot, with the bubble rising above the top edge of the nav. */
    var overlap = Math.round(height * 0.58);
    var left = Math.round(slotRect.left + (slotRect.width - width) / 2);
    var top = Math.round(slotRect.top - overlap);

    target.style.setProperty('--yf-lookfor-left', Math.max(0, left) + 'px');
    target.style.setProperty('--yf-lookfor-top', Math.max(0, top) + 'px');
    setChatSlotDocked(true);
    return true;
  }

  function floatLookforEntryPoint() {
    if (!isMobile()) {
      clearLookforFloat();
      return false;
    }

    var candidate = findLookforEntry(document);
    var target = compactLookforTarget(candidate);
    if (!target) {
      clearLookforFloat();
      return false;
    }

    if (floatingLookforTarget && floatingLookforTarget !== target) clearLookforFloat(floatingLookforTarget);

    var rect = target.getBoundingClientRect();
    var isCompactLauncher = rect.width <= 190 && rect.height <= 190;
    if (!isCompactLauncher) {
      clearLookforFloat(target);
      return false;
    }

    elevateLookforAncestors(target);
    target.setAttribute('data-yf-lookfor-front-layer', 'true');
    target.setAttribute('data-yf-lookfor-floating', 'true');
    target.removeAttribute('aria-hidden');
    floatingLookforTarget = target;
    positionLookforOverChatSlot(target);
    return true;
  }

  function openLookforChat() {
    if (window.Lookfor && typeof window.Lookfor.open === 'function') {
      window.Lookfor.open();
      return true;
    }
    if (window.lookfor && typeof window.lookfor.open === 'function') {
      window.lookfor.open();
      return true;
    }
    var entry = findLookforEntry(document);
    if (entry && typeof entry.click === 'function') {
      entry.click();
      return true;
    }
    return false;
  }

  function setCartCount(count) {
    var counter = document.querySelector('[data-yf-mobile-cart-count]');
    if (!counter) return;
    var safeCount = Math.max(0, parseInt(count, 10) || 0);
    counter.textContent = String(safeCount);
    counter.hidden = safeCount < 1;
    counter.setAttribute('aria-label', safeCount + (safeCount === 1 ? ' item in cart' : ' items in cart'));
  }

  function cartJsonUrl() {
    var base = window.dynamicURLs && window.dynamicURLs.cart ? window.dynamicURLs.cart : '/cart';
    return String(base).replace(/\.js(?:\?.*)?$/, '') + '.js';
  }

  function refreshCartCount(delay) {
    if (cartRefreshTimer) window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function () {
      var token = ++cartRequestToken;
      fetch(cartJsonUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      }).then(function (cart) {
        if (token !== cartRequestToken) return;
        setCartCount(cart && cart.item_count);
      }).catch(function () {});
    }, typeof delay === 'number' ? delay : 0);
  }

  function installCartFetchWatcher() {
    if (window.__YF_CART_FETCH_WATCHER__ || !window.fetch) return;
    window.__YF_CART_FETCH_WATCHER__ = true;
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var result = originalFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/i.test(url)) {
        Promise.resolve(result).then(function () {
          refreshCartCount(80);
          window.setTimeout(function () { refreshCartCount(0); }, 500);
        }, function () {});
      }
      return result;
    };
  }

  function syncAll() {
    syncLocationState();
    if (floatingLookforTarget && document.documentElement.contains(floatingLookforTarget) && elementIsVisible(floatingLookforTarget)) {
      positionLookforOverChatSlot(floatingLookforTarget);
    } else {
      floatLookforEntryPoint();
    }
    var dialog = getMenuDialog();
    if (dialog && dialog.open) portalNavIntoMenu();
    else restoreNavToBody();
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(function () {
      syncScheduled = false;
      syncAll();
    });
  }

  document.addEventListener('click', function (event) {
    var locationButton = closest(event.target, '[data-yf-mobile-location-button]');
    if (locationButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu(function () {
        window.setTimeout(function () {
          toggleLocation();
          syncLocationState();
        }, 0);
      });
      return;
    }

    var menuButton = closest(event.target, '[data-yf-mobile-menu-button]');
    if (menuButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleMenu();
      return;
    }

    var chatSlot = closest(event.target, '[data-yf-mobile-chat-slot]');
    if (chatSlot) {
      event.preventDefault();
      closeMenu(function () {
        openLookforChat();
        window.setTimeout(floatLookforEntryPoint, 500);
      });
      return;
    }


  }, false);


  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (/\/cart\/add/i.test(action) || form.matches('[data-type="add-to-cart-form"]')) {
      window.setTimeout(function () { refreshCartCount(0); }, 500);
      window.setTimeout(function () { refreshCartCount(0); }, 1200);
    }
  }, true);

  ['cart:add', 'cart:change', 'cart:update', 'cart:replace', 'cart:refresh', 'product-form:submit'].forEach(function (name) {
    document.addEventListener(name, function () {
      refreshCartCount(name === 'cart:update' ? 20 : 250);
    });
  });

  document.addEventListener('modal-open', function (event) {
    var host = getMenuHost();
    var dialog = getMenuDialog();
    if (!host || !dialog) return;
    if (event.target === host || event.target === dialog || host.contains(event.target)) {
      window.setTimeout(portalNavIntoMenu, 0);
    }
  });

  document.addEventListener('modal-close', function (event) {
    var host = getMenuHost();
    if (host && (event.target === host || host.contains(event.target))) {
      window.setTimeout(restoreNavToBody, 380);
    }
  });

  function start() {
    if (!document.body) return;
    installCartFetchWatcher();

    externalChatObserver = new MutationObserver(function (mutations) {
      var shouldSync = false;
      shouldSync = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return false;
          try {
            if (node.matches && node.matches(LOOKFOR_CANDIDATE_SELECTOR)) return true;
            if (node.querySelector && node.querySelector(LOOKFOR_CANDIDATE_SELECTOR)) return true;
            if (node.matches && node.matches('[data-yf-mobile-bottom-nav], [data-yf-mobile-menu-trigger], #yf-location-widget')) return true;
          } catch (error) {}
          return false;
        });
      });
      if (shouldSync) scheduleSync();
    });
    externalChatObserver.observe(document.body, { childList: true, subtree: true });

    refreshCartCount(0);
    syncAll();
    [150, 500, 1200, 2500, 5000, 9000, 15000].forEach(function (delay) {
      window.setTimeout(syncAll, delay);
    });
    window.setTimeout(function(){ refreshCartCount(0); }, 1200);
  }

  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', function () { window.setTimeout(syncAll, 120); });
  window.addEventListener('pageshow', function () {
    refreshCartCount(0);
    syncAll();
  });
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', scheduleSync);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
